var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"mb-10",attrs:{"justify":"center"}},[_c('v-card',{attrs:{"flat":"","max-width":"500","width":"95%","color":"transparent"}},[_c('Name'),_c('AddressBook'),_c('PhoneBook'),_c('Cards'),_c('Password'),_c('v-divider'),_c('DeleteAccount')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }